import React from 'react'
import { channelStore } from '../../app/stores'
import { TextInput, Button, CreateForm } from '../../lib'

const isLowerCase = (value) => {
  if (value !== value.toLowerCase()) { return 'Names must be lowercase.' }
}

const hasNoSpaces = (value) => {
  if (/\s\./.test(value)) { return 'Names must be without spaces or periods.' }
}

const shorterThan = (num) => (value) => {
  if (value && value.length >= num) { return `Names must be shorter than ${num} characters.` }
}

const schema = {
  channel: {
    placeholder: 'e.g. pricing-support, personal-website',
    status: 'Names must be lowercase, without spaces or periods, and shorter than 22 characters.',
    required: true,
    validators: [isLowerCase, hasNoSpaces, shorterThan(22)]
  }
}

const AddChannelForm = ({ fieldsData, isValid, isSubmitting, handleSubmit }) => {
  const { error } = channelStore
  return (
    <form className='AddChannelForm' onSubmit={handleSubmit}>
      <TextInput {...fieldsData.channel}
        error={error || fieldsData.channel.error}
      />
      <Button disabled={!isValid} type='submit' large>
        {isSubmitting ? 'Creating...' : 'Create Channel'}
      </Button>
    </form>
  )
}

AddChannelForm.displayName = 'AddChannelForm'

export default CreateForm(AddChannelForm, schema)



// WEBPACK FOOTER //
// ./src/channel/add/AddChannelForm.js